<!-- 処分業者詳細 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>処分業者詳細</v-toolbar-title>
      </v-toolbar>
      <v-card
        class="mx-auto"
        max-width="600"
        outlined
      >
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-row align="center">
                <v-col cols="12" md="6">
                  <v-list-item-title class="text-h5">
                    {{ disposer.name }}
                  </v-list-item-title>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-end">
                  <v-checkbox
                    v-model="disposer.invisible"
                    :disabled="!disposer.use_deleted"
                    label="非表示にする"
                    hide-details="auto"
                    @change="updateInvisible"
                  />
                </v-col>
              </v-row>
              <v-list-item-subtitle> {{ disposer.subscriber_number }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>
              <div>〒{{ disposer.zip_code }}</div>
              <div>{{ disposer.address }}</div>
            </v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>{{ disposer.phone_number }}</v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-fax</v-icon>
            </v-list-item-icon>
            <v-list-item-subtitle>{{ disposer.fax_number }}</v-list-item-subtitle>
          </v-list-item>
        </v-card-text>
      </v-card>

      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="disposer.locations"
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.address`]="{ item }">
            <span :title="item.address">{{ item.address | truncate(25) }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import { mapActions} from 'vuex'
import Confirm from "@/components/Confirm.vue";
export default {
  name: 'DriverDisposerShow',
  components: {Confirm},
  filters: {
  },
  mixins: [
  ],
  data () {
    return {
      breadcrumbs: [
        { text: '処分業者一覧', disabled: false, to: '/driver/masters/disposers', exact: true },
        { text: '処分業者詳細', disabled: true, to: '' },
      ],
      tableHeaders: [
        { value: 'location_code', text: '事業場コード' },
        { value: 'location_name', text: '事業場名称' },
        { value: 'location_type_name', text: '事業者区分' },
        { value: 'zip_code', text: '郵便番号' },
        { value: 'address', text: '所在地' },
        { value: 'phone_number', text: '電話番号' },
        { text: '', value: 'editable', align: 'end' },
      ],
      disposer: {},
      initialInvisible: false,
    }
  },
  created() {
    this.fetchDisposer({ id: this.$route.params.id }).then((content) => {
      this.disposer = content;
      this.initialInvisible = content.invisible;
    })
  },
  methods: {
    ...mapActions('DriverMasterDisposer', {
      fetchDisposer: 'show',
      deleteDisposer: 'destroy',
      updateDisposer: 'update',
    }),
    updateInvisible() {

      if (!this.initialInvisible && this.disposer.invisible) {

        let modalOption = { title: '更新', message: '関連する運搬ルートを含め非表示で更新します。よろしいですか？', options: { titleColor: 'blue' } }
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            const params = {
              invisible: this.disposer.invisible
            }
            this.updateDisposer({ id: this.disposer.id, params })
          } else {
            this.disposer.invisible = false;
          }
        })

      } else {
        const params = {
          invisible: this.disposer.invisible
        }
        this.updateDisposer({ id: this.disposer.id, params })
      }
    }
  }
}
</script>

<style scoped>

</style>
